module.exports = __webpack_public_path__ + "static/media/home-img-other.425082ef.jpg";